import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//

export default {
  props: {
    endTime: {
      type: Number,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    onCountDownFinish: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      countdownText: '',
      timer: null,
      time: this.currentTime
    };
  },
  watch: {
    currentTime: function currentTime(val) {
      this.updateTime();
      this.time = val;
    },
    endTime: function endTime(val) {
      this.updateTime();
    }
  },
  methods: {
    startTimer: function startTimer() {
      var _this = this;
      this.updateTime(); // 立即更新一次时间
      this.timer = setInterval(function () {
        _this.time = _this.time + 1000;
        _this.updateTime();
      }, 1000); // 每秒更新一次时间
    },

    updateTime: function updateTime() {
      var timeDifference = Math.abs(this.endTime - this.time);
      if (timeDifference < 0 || timeDifference > 86400000) {
        // 大于一天不显示倒计时文案
        this.countdownText = '';
        return;
      }
      if (timeDifference <= 1000) {
        this.countdownText = '已结束';
        if (this.onCountDownFinish) {
          this.$emit('onCountDownFinish');
        }
        clearInterval(this.timer);
        return;
      }
      // 计算小时、分钟和秒
      var hours = Math.floor(timeDifference / (1000 * 60 * 60));
      var minutes = Math.floor(timeDifference % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(timeDifference % (1000 * 60) / 1000);
      this.countdownText = "".concat(this.formatNumber(hours), ":").concat(this.formatNumber(minutes), ":").concat(this.formatNumber(seconds));
    },
    formatNumber: function formatNumber(n) {
      return n < 10 ? '0' + n : n;
    },
    clearTimer: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
  }
};